import { ajaxSend } from 'api/api';

import type {
  ChatFlowGetAllLanguagesPayloadT,
  ChatFlowGetAllLanguagesResponseT,
} from './types';

export function getAllLanguages(payload: ChatFlowGetAllLanguagesPayloadT) {
  const request = {
    path: `/v1/flows/${payload.flowID}/languages`,
  };
  return ajaxSend<ChatFlowGetAllLanguagesResponseT>(request);
}
